import { useState } from 'react';

import { useGenericModal } from '..';
import {
  DeleteRuleSetModal,
  DeleteRuleSetModalProps,
} from './delete-rule-set-modal';

export const useDeleteRuleSetModal = (
  props?: Partial<DeleteRuleSetModalProps>
) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const [ruleSetId, setRuleSetId] = useState<string | undefined>();
  const [ruleSetName, setRuleSetName] = useState('');

  const modalComponent = (
    <DeleteRuleSetModal
      testId={props?.testId}
      modalRef={modalRef}
      onClose={closeModal}
      ruleSetId={ruleSetId}
      ruleSetName={ruleSetName}
    />
  );

  const openDeleteModal = (options: {
    ruleSetId: string;
    ruleSetName: string;
  }) => {
    setRuleSetId(options.ruleSetId);
    setRuleSetName(options.ruleSetName);
    openModal();
  };

  return {
    modalRef,
    openModal: openDeleteModal,
    closeModal,
    deleteRuleSetModal: modalComponent,
  };
};
